import React, { Component } from 'react'
import Icon from 'svg-inline-react'
import TARGET_ICON from '!svg-inline?removeTags=true!images/svg/user-target.svg'
import MAGNIFY_ICON from '!svg-inline?removeTags=true!images/svg/user-search.svg'
import { leandataAction } from 'app/modules/rules/models'

import './style.styl'

class LeandataFilter extends Component {

  constructor(props) {
    super(props)

    this.props.setPageValidity(true)
    this.props.updateAction({
      ...leandataAction
    })
  }

  renderCopySection() {
    return (
      <div className="rules-choice-content drift-form">
        <p><Icon src={TARGET_ICON} />When a site visitor chats in to Drift, we’ll check LeanData to find the right rep to connect them with. If a rep is found, we’ll route the conversation to that person.</p>
        <p><Icon src={MAGNIFY_ICON} />If we can’t find a Drift teammate to connect the site visitor with, we’ll carry on with your other Routing Rules.</p>
      </div>
    )
  }

  render() {
    return (
      <div className="rules-targeted-accounts-filter rules-choice">
        <header>
          <h1>How the LeanData routing rule works</h1>
        </header>
        <div className="rules-editor-content">
          {this.renderCopySection()}
        </div>
      </div>
    )
  }
}

export default LeandataFilter



// WEBPACK FOOTER //
// ./src/scripts/components/settings/Rules/components/FilterEditor/LeandataFilter/index.js